/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateCustomerProfileDto = {
  /**
   * Customer full name; required. Need not be unique (several clients may share the same name).
   */
  customerName: string;
  /**
   * Identity document number (e.g. CI Bolivia); optional, but must be unique when provided
   */
  identityDocumentNumber?: string;
  /**
   * Customer email
   */
  customerEmail?: string;
  /**
   * Customer phone
   */
  customerPhone?: string;
  /**
   * Optional reference number 1 (max 2 per customer)
   */
  referenceNumber1?: string;
  /**
   * Optional reference number 2 (max 2 per customer)
   */
  referenceNumber2?: string;
  /**
   * Customer address
   */
  customerAddress?: string;
  /**
   * Date of birth
   */
  dateOfBirth?: string;
  /**
   * Gender
   */
  gender?: CreateCustomerProfileDto.gender;
  /**
   * Preferred payment method
   */
  preferredPaymentMethod?: CreateCustomerProfileDto.preferredPaymentMethod;
  /**
   * Customer notes
   */
  customerNotes?: string;
  /**
   * Loyalty tier
   */
  loyaltyTier?: CreateCustomerProfileDto.loyaltyTier;
  /**
   * Marketing consent
   */
  marketingConsent: boolean;
  /**
   * Referral source
   */
  referralSource?: string;
};
export namespace CreateCustomerProfileDto {
  /**
   * Gender
   */
  export enum gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER',
  }
  /**
   * Preferred payment method
   */
  export enum preferredPaymentMethod {
    CASH = 'CASH',
    CARD = 'CARD',
    BANK_TRANSFER = 'BANK_TRANSFER',
    QR_CODE = 'QR_CODE',
  }
  /**
   * Loyalty tier
   */
  export enum loyaltyTier {
    BRONZE = 'BRONZE',
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    PLATINUM = 'PLATINUM',
  }
}
